<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:33:34
 * @Description: 设备登记
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    title="设备登记"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="系统设备"
            prop="xtsbDm"
          >
            <select-sb
              ref="selectSb"
              v-model="fd.xtsbDm"
              type="jc"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="数量"
            prop="xfsbsl"
          >
            <el-input-number
              v-model="fd.xfsbsl"
              class="c-form__input-number"
              :min="1"
              label="请输入数量"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="出厂日期"
            prop="ccrq"
          >
            <el-date-picker
              v-model="fd.ccrq"
              placeholder="请选择出厂日期"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="合格证"
            prop="hgz"
          >
            <el-radio-group
              v-model="fd.hgz"
              class="c-form__radio-group"
            >
              <el-radio label="Y">
                有
              </el-radio>
              <el-radio label="N">
                无
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="产品型号/生产厂家"
            prop="xfsbxh"
          >
            <el-input
              v-model="fd.xfsbxh"
              class="c-form__textarea"
              type="textarea"
              placeholder="请输入产品型号/生产厂家"
              :autosize="{ minRows: 3, maxRows: 5}"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="符合法定市场准入规则的证明文件"
            prop="xfsbzmwj"
          >
            <el-input
              v-model="fd.xfsbzmwj"
              class="c-form__textarea"
              type="textarea"
              placeholder="请输入符合法定市场准入规则的证明文件"
              :autosize="{ minRows: 3, maxRows: 5}"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="备注"
            prop="bz"
          >
            <el-input
              v-model="fd.bz"
              class="c-form__textarea"
              type="textarea"
              placeholder="请输入备注"
              :autosize="{ minRows: 3, maxRows: 5}"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { xfsbService } from './xfsb.service';
export default {
  name: 'JcsbAddDialog',
  props: {
    xmid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示
      sbList: [], // 设备名称列表

      /* 表单参数 Start */
      fd: {
        xmId: null,
        xtsbDm: null, // 系统设备代码
        xfxtDm: null, // 系统代码
        xfsbDm: null, // 设备代码
        xfsbsl: 0, // 数量
        ccrq: null, // 出厂日期
        hgz: null, // 合格证
        cpxhsccj: null, // 产品型号/生产厂家
        xfsbzmwj: null, // 符合法定市场准入规则的证明文件
        bz: null // 备注
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {

        xtsbDm: [
          this.$validUtils.required('设备名称')
        ], // 设备名称
        xfsbsl: [
          this.$validUtils.required('数量'),
          this.$HMValidator.number('数量'),
          this.$validUtils.maxNumberValid('数量')
        ], // 数量
        xfsbxh: [this.$HMValidator.maxLength('产品型号/生产厂家', 300)],
        xfsbzmwj: [this.$HMValidator.maxLength('符合法定市场准入规则的证明文件', 300)],
        bz: [this.$HMValidator.maxLength('备注', 300)]
      }
      /* 表单校验规则 End */

    };
  },
  computed: {
    /** 检测内容类型 */
    jcnrType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JC_JCNR) {
        return enums.IFF_JC_JCNR;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description:
     * @return {*}
     */
    async init () {
      if (this.fd.xtsbDm && this.fd.xtsbDm.includes('/')) {
        [this.fd.xfxtDm, this.fd.xfsbDm] = this.fd.xtsbDm.split('/');
      }
    },

    /**
     * @description: 修改保存
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          [this.fd.xfxtDm, this.fd.xfsbDm] = this.fd.xtsbDm.split('/');
          [this.fd.xfxtmc, this.fd.xfsbmc] = this.$refs.selectSb.getSbMc();
          xfsbService.saveXfsb(_this.fd)
            .then(rsp => {
              this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.error('检测设备新增错误！', err);
              this.loading = false;
            });
        }
      });
    },

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.fd.xmId = this.$route.params.xmId;
    // this.init();
  }
};
</script>
